import { countriesCodes } from 'src/i18n/localeHelpers';
import axios from '../../../shared/utils/axios';
import { actionSuccess } from '../utils';

export const FETCH_BANK_ENTITIES = 'FETCH_BANK_ENTITIES';

const fetchBankEntitiesEndpoint = `${process.env.REACT_APP_API_URL}bank-entities`;

const localesToFetch = [countriesCodes.peru, countriesCodes.colombia];

export const fetchBankEntities = locale => async dispatch => {
  if (locale && !localesToFetch.includes(locale)) return;
  try {
    const response = await axios.get(fetchBankEntitiesEndpoint);
    dispatch(actionSuccess(FETCH_BANK_ENTITIES, response?.data?.data));

    return response.data;
  } catch (error) {
    console.error(error);
    return false;
  }
};
